enum KycDetailsPageEnum {
  basicdetails = 'basicdetails',
  panbankdetails = 'panbankdetails',
  gstotherdetails = 'gstotherdetails',
}

export default KycDetailsPageEnum;
